var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJichuCuowutishiXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(1 0 0 -1 1 15)",
    fill: "#4C6AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3V7",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 4.9a.6.6 0 10-1.2 0 .6.6 0 001.2 0z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/jichu_cuowutishi_xian.fa874c44.svg";
export { SvgJichuCuowutishiXian as ReactComponent };